import { ReactComponent as SiemensIcon } from "../../../assets/icons/siemens_icon.svg";
import { ReactComponent as PhilipsIcon } from "../../../assets/icons/philips_icon.svg";
import { ReactComponent as GEIcon } from "../../../assets/icons/GE_healthcare_icon.svg";
import { ReactComponent as GEDarkIcon } from "../../../assets/icons/GE_healthcare_dark_icon.svg";
import { ReactComponent as FujifilmIcon } from "../../../assets/icons/fujifilm_icon.svg";
import { ReactComponent as FujifilmDarkIcon } from "../../../assets/icons/fujifilm_dark_icon.svg";
import { ReactComponent as HitachiIcon } from "../../../assets/icons/hitachi_logo.svg";
import { ReactComponent as HitachiDarkIcon } from "../../../assets/icons/hitachi_dark_logo.svg";
import { ReactComponent as UnitedImagingIcon } from "../../../assets/icons/united_imaging_icon.svg";
import { ReactComponent as UnitedImagingDarkIcon } from "../../../assets/icons/united_imaging_dark_icon.svg";
import { ReactComponent as CanonIcon } from "../../../assets/icons/canon_icon.svg";

export const MAGNETS = [
    {
        id: "Siemens",
        name: "Siemens",
        icon: SiemensIcon,
        hasFieldStrength: false,
    },
    {
        id: "GE",
        name: "GE Healthcare",
        icon: GEIcon,
        darkIcon: GEDarkIcon,
        hasFieldStrength: true,
    },
    {
        id: "Philips",
        name: "Philips",
        icon: PhilipsIcon,
        hasFieldStrength: false,
    },
    {
        id: "Fujifilm",
        name: "Fujifilm",
        icon: FujifilmIcon,
        darkIcon: FujifilmDarkIcon,
        hasFieldStrength: false,
    },
    {
        id: "Hitachi",
        name: "Hitachi",
        icon: HitachiIcon,
        darkIcon: HitachiDarkIcon,
        hasFieldStrength: false,
    },
    {
        id: "United Imaging",
        name: "United Imaging",
        icon: UnitedImagingIcon,
        darkIcon: UnitedImagingDarkIcon,
        hasFieldStrength: false,
    },
    {
        id: "Canon",
        name: "Canon",
        icon: CanonIcon,
        hasFieldStrength: false,
    },
    {
        id: "Other",
        name: "Other",
        icon: null,
        hasFieldStrength: false,
    },
    {
        id: "High Spec",
        name: "High Spec",
        icon: null,
        hasFieldStrength: false,
    },
];

/** Returns the icon component for a stored magnet_type value, or null if none applies. */
export function getMagnetIcon(magnetType, isDark = false) {
    const magnet = MAGNETS.find((m) => m.id === magnetType);
    if (!magnet) return null;
    return (isDark && magnet.darkIcon) || magnet.icon || null;
}
